export default __webpack_public_path__ + "static/media/HeatTreatmentImg.059fef8e.jpg";